module.exports = function(marker, revealer) {

    this.handle = function(action, hide) {
        return function() {
            revealer.toggle($('#reveal-action-' + action + '-role'));
            revealer.hide($('#reveal-action-' + hide + '-role'));
            marker.addIdsToForm($("#marker-action-"+action+"-role"));
        }
    };

    $("#reveal-action-assign-role .marker-action-button").on("click", this.handle('assign', 'remove'));
    $("#reveal-action-remove-role .marker-action-button").on("click", this.handle('remove', 'assign'));
};
